import { Flex, Props } from '../flex/Flex';
import styled from '@emotion/styled';

export const Column = styled(Flex)<Omit<Props, 'direction'>>`
  flex-direction: column;
`;
